import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { ExpirationWidget } from "../components/ExpirationWidget";

export const getRequirementExpirationWidget = (
  requirement: PayeeRequirement
) => {
  const expirationDate = requirement.expiresAt;

  if (!expirationDate) {
    return null;
  }

  return <ExpirationWidget expirationDate={expirationDate} />;
};
